import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://195074575d3735a1cea308e780ec5222@o4506285824016384.ingest.us.sentry.io/4509741014908928",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

createRoot(document.getElementById("root")!).render(<App />);
